// @mui
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
// types
import { ParticipationStatus, ReportColumnDto } from 'src/api';
// utils
import { spaceOnCapital } from 'src/utils/string-utils';
// constants
import { booleanAggregationModels } from '../constants/aggregation-model/boolean';

export function AttendedColumn(index: number) {
  const column = {
    field: 'attended',
    headerName: 'Attended',
    description: 'Whether the member attended the class',
    type: 'boolean',
    width: 150,
    index,
    groupable: true,
    availableAggregationFunctions: [...booleanAggregationModels, 'Attendance'],
    headerAlign: 'center',
    align: 'center',
    valueGetter: (value: any, row: any) => {
      if (row && row.participationStatus) {
        return calculateAttendance(row.participationStatus);
      }
      return null;
    },
    renderCell: (params: any) => {
      if (params.value === true) {
        return <CheckIcon />;
      }
      if (params.value === false) {
        return <ClearIcon color="disabled" />;
      }

      return null;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}

const calculateAttendance = (status: ParticipationStatus) => {
  if (
    status === spaceOnCapital(ParticipationStatus.OptedOut) ||
    status === spaceOnCapital(ParticipationStatus.OptedOutTooLate) ||
    status === spaceOnCapital(ParticipationStatus.NeverMet) ||
    status === spaceOnCapital(ParticipationStatus.OnWaitingList)
  ) {
    return false;
  }
  return true;
};
